'use client';
import Line from '@/components/common/Line';

export default function TopBrandsSection() {
    const brands = [
        { src: '/images/img_nike_logo_1978_1.svg', alt: 'Nike', width: 156, height: 82 },
        { src: '/images/img_adidas_logo_1.svg', alt: 'Adidas', width: 118, height: 82 },
        { src: '/images/img_puma_logo_logo_svgrepo_com.svg', alt: 'Puma', width: 166, height: 90 },
        { src: '/images/img_zara_logo_svgrepo_com.svg', alt: 'Zara', width: 138, height: 56 },
        { src: '/images/img_levis_logo_svgrepo_com.svg', alt: 'Levis', width: 120, height: 66 },
        { src: '/images/img_h_m_logo_1.svg', alt: 'H&M', width: 98, height: 64 }
    ]

    return (
        <section className="w-full py-8 sm:py-10 lg:py-12">
            <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[60px]">
                <div className="w-full max-w-[1804px] mx-auto bg-primary-brand rounded-2xl sm:rounded-3xl lg:rounded-[30px] p-4 sm:p-6 lg:p-[26px]">
                    <div className="flex flex-col lg:flex-row items-center gap-6 sm:gap-8 lg:gap-0">
                        {/* Brand Section Text */}
                        <div className="flex flex-col gap-4 sm:gap-5 lg:gap-[26px] w-full lg:w-[18%] text-center lg:text-left">
                            <div className="flex flex-col gap-0">
                                <h2 className="text-3xl sm:text-4xl lg:text-7xl text-text-on-dark font-medium leading-9 sm:leading-10 lg:leading-10xl">
                                    Top Brands
                                </h2>
                                <p className="text-3xl sm:text-4xl lg:text-7xl text-text-on-dark font-semibold leading-9 sm:leading-10 lg:leading-10xl">
                                    Best Quality.
                                </p>
                            </div>

                            <p className="text-base sm:text-lg lg:text-xl text-text-on-dark font-medium leading-6 sm:leading-7 lg:leading-5xl">
                                Handpicked styles, from top brands, just for you.
                            </p>

                            <button className="text-xl sm:text-2xl lg:text-5xl text-text-on-dark font-semibold leading-6 sm:leading-7 lg:leading-7xl hover:opacity-80 transition-opacity duration-200 flex items-center gap-2 sm:gap-3 lg:gap-[12px] justify-center lg:justify-start group">
                                Shop Top Brands
                                <img
                                    src="/images/img_arrowright.svg"
                                    alt=""
                                    className="w-5 h-5 sm:w-6 sm:h-6 lg:w-[24px] lg:h-[24px] group-hover:translate-x-1 transition-transform duration-200"
                                />
                            </button>
                        </div>

                        {/* Brands Grid */}
                        <div className="flex flex-row items-center gap-6 sm:gap-8 lg:gap-0 w-full lg:w-[82%] justify-center lg:justify-between px-4 sm:px-6 lg:px-[40px]">
                            <Line className="hidden lg:block w-[1.5px] h-[100px] bg-white/40 self-center" />

                            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 sm:gap-8 lg:gap-[46px] items-center justify-items-center py-2 sm:py-2.5 lg:py-[10px] w-full">
                                {brands.map((brand, index) => (
                                    <img
                                        key={index}
                                        src={brand.src}
                                        alt={brand.alt}
                                        className="max-w-[80px] sm:max-w-[100px] lg:max-w-none h-auto object-contain hover:scale-105 transition-transform duration-200"
                                        style={{
                                            width: `${brand.width}px`,
                                            height: `${brand.height}px`
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}